module.exports = {"130105001":"革新街街道","130105003":"新华路街道","130105004":"宁安街道","130105005":"东焦街道","130105006":"西苑街道","130105007":"合作路街道","130105008":"联盟街道","130105009":"石岗街道","130105011":"天苑街道","130105012":"北苑街道","130105013":"赵陵铺路街道","130105014":"西三庄街道","130105015":"大郭街道","130105016":"杜北街道","130105017":"赵佗路街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130105.json
// module id = 59
// module chunks = 0